<link rel="stylesheet" href="../../node_modules/vue3-calendar-heatmap/dist/vue3-calendar-heatmap.css">

<template>
  <InternalNavBar />
  <div class="row" style="height: 10vh"></div>
  <div class="row justify-center">
    <div class="col-3" v-bind:content="profileData">
      <div class="row justify-center">
        <q-avatar size="22vw">
          <img id="mainPFP" v-bind:src="PFPSrc === 'blank' ? require(`../assets/blank-avatar.png`) : PFPSrc" />
        </q-avatar>
      </div>
      <text class="text-h4" style="font-family: Lato; font-weight: 500; text-align: left;">
        {{ profileData.name }}
      </text><br>
      <text class="text-h5 text-grey-10" style="font-family: Lato; font-weight: 500; text-align: left;">
        {{ profileData.username }}
      </text>
      <div class="text-h7 text-center" style="font-family: Lato; font-weight: 350; display: block">
        <q-icon name="school" size="md" />
        <br>
        {{ profileData.grade }} @ {{ profileData.school }}
      </div>
      <div class="text-h7 text-center" style="font-family: Lato; font-weight: 350; display: block; padding-top: 1vh">
        <q-icon name="email" size="md" />
        <br>
        {{ profileData.email }}
      </div>
      <div class="text-h7 text-center" style="font-family: Lato; font-weight: 350; display: block; padding-top: 1vh">
        <q-icon name="savings" size="md" />
        <br>
        {{ profileData.credits }} credits
      </div>
      <br />
      <q-separator />
      <p
        class="text-h7"
        style="font-family: Lato; font-weight: 350; display: block"
      >
        <i
          >{{profileData.description == null ? "Here is supposed to be a short description about myself. It should be            about two sentences long." : profileData.description}}</i
        >
      </p>
    </div>


    <div class="col-7">
      <q-tabs v-model="tab"
            dense
            class="text-black"
            active-color="white"
            indicator-color="white"
            align="left"
            active-bg-color="teal-5"
            style="margin-top: 3vh; font-family: Montserrat;"
            no-caps
      >
        <q-tab name="overview" label="Overview" />
        <q-tab name="stats" label="Statistics" />
        <q-tab name="sessions" label="Sessions" />
        <q-tab name="verification" label="Verification and Subjects Profile" />
        <q-tab name="edit" label="Edit Profile" />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="overview">
          <div class="row">
            <p
                class="text-h6"
                style="font-family: Lato; font-weight: 700; text-align: left; margin-bottom: 0"
            >
              Subjects Taught
            </p>
          </div>
          <q-scroll-area style="height: 32vh; max-width: 100%">
            <div class="row no-wrap" v-for="tutoredSubject in tutoredData" v-bind:key="tutoredSubject" style="float: left">
              <q-card class="my-card q-ma-md q-pa-sm" style="background-color: #4a7d9d; color: white; margin-left: 1vw; margin-right: 1vw; width: 15vw;">
                <q-card-section style="text-align: center" class="q-pa-sm">
                  <div
                      class="text-h5"
                      style="font-family: Lato; font-weight: 600"
                  >
                    {{ tutoredSubject.subject }}
                  </div>
                </q-card-section>
                <q-card-section class="q-pa-sm">
                  <div
                      class="text-h7"
                      style="font-family: Lato; font-weight: 500"
                  >
                    <p class="text-h4" style="display: inline">{{ tutoredSubject.totalDuration }} </p>
                    hours spent tutoring
                  </div>
                  <div
                      class="text-h7"
                      style="font-family: Lato; font-weight: 500"
                  >
                    <p class="text-h4" style="display: inline">{{ tutoredSubject.creditsEarned }} </p>
                    credits earned
                  </div>
                  <div
                      class="text-h7"
                      style="font-family: Lato; font-weight: 500"
                  >
                    <p class="text-h4" style="display: inline">{{ tutoredSubject.positiveRatings }} </p>
                    positive ratings
                  </div>
                </q-card-section>
              </q-card>
            </div>
          </q-scroll-area>
          <div class="row">
            <p
                class="text-h6"
                style="font-family: Lato; font-weight: 700; text-align: left; margin-bottom: 0; margin-top: 1vh"
            >
              Still Learning
            </p>
          </div>
          <q-scroll-area style="height: 32vh; max-width: 100%">
            <div class="row no-wrap" v-for="learnedSubject in learningData" v-bind:key="learnedSubject" style="float: left">
              <q-card class="my-card q-ma-md q-pa-sm" style="background-color: #4a7d9d; color: white; margin-left: 1vw; margin-right: 1vw; width: 15vw;">
                <q-card-section style="text-align: center" class="q-pa-sm">
                  <div
                      class="text-h5"
                      style="font-family: Lato; font-weight: 600"
                  >
                    {{ learnedSubject.subject }}
                  </div>
                </q-card-section>
                <q-card-section class="q-pa-sm">
                  <div
                      class="text-h7"
                      style="font-family: Lato; font-weight: 500"
                  >
                    <p class="text-h4" style="display: inline">{{ learnedSubject.totalDuration }} </p>
                    hours spent learning
                  </div>
                  <div
                      class="text-h7"
                      style="font-family: Lato; font-weight: 500"
                  >
                    <p class="text-h4" style="display: inline">{{ learnedSubject.creditsEarned }} </p>
                    credits spent
                  </div>
                  <div
                      class="text-h7"
                      style="font-family: Lato; font-weight: 500"
                  >
                    <p class="text-h4" style="display: inline">{{ learnedSubject.positiveRatings }} </p>
                    amazing experiences
                  </div>
                </q-card-section>
              </q-card>

            </div>
          </q-scroll-area>

        </q-tab-panel>
        <q-tab-panel name="stats">
          <text class="text-h6" style="font-family: Lato;">
            <b>Tutoring Activity</b>
          </text>

          <calendar-heatmap :values="tutoredHeatMapValues" :end-date="endDate" :max="4" :range-color="['#ebedf0', '#87a5af', '#658e95', '#44787a', '#24635e', '#004d40']" :no-data-text="'No tutoring sessions on this date'" :tooltip-unit="'tutoring sessions'" />

          <div class="row" style="justify-content: space-evenly; margin-top: 1vh; margin-bottom: 2vh">
            <q-card class="my-card" style="height: 12vh">
              <q-card-section style="text-align: center">
                <div class="text-h3" style="
                    font-family: Lato;
                    font-weight: 500;
                    color: #4a7d9d;
                  ">
                  {{parseInt(totalTutoredSessions, 10)}}
                </div>
                <div class="text-h7" style="font-family: Lato; font-weight: 500">
                  tutoring sessions
                </div>
              </q-card-section>
            </q-card>
            <q-card class="my-card" style="height: 12vh">
              <q-card-section style="text-align: center">
                <div class="text-h3" style="
                    font-family: Lato;
                    font-weight: 500;
                    color: #4a7d9d;
                  ">
                  {{Math.round(parseFloat(totalTutoredHours) * 100) / 100}}
                </div>
                <div class="text-h7" style="font-family: Lato; font-weight: 500">
                  hours tutored
                </div>
              </q-card-section>
            </q-card>
            <q-card class="my-card" style="height: 12vh">
              <q-card-section style="text-align: center">
                <div class="text-h3" style="
                    font-family: Lato;
                    font-weight: 500;
                    color: #4a7d9d;
                  ">
                  {{tutoredData.length}}
                </div>
                <div class="text-h7" style="font-family: Lato; font-weight: 500">
                  subjects taught
                </div>
              </q-card-section>
            </q-card>
            <q-card class="my-card" style="height: 12vh">
              <q-card-section style="text-align: center">
                <div class="text-h3" style="
                    font-family: Lato;
                    font-weight: 500;
                    color: #4a7d9d;
                  ">
                  {{parseInt(totalCreditsEarned, 10)}}
                </div>
                <div class="text-h7" style="font-family: Lato; font-weight: 500">
                  credits earned
                </div>
              </q-card-section>
            </q-card>
          </div>

          <q-separator />
          <text class="text-h6" style="font-family: Lato">
            <b>Learning Activity</b>
          </text>

          <calendar-heatmap :values="learningHeatMapValues" :end-date="endDate" :max="4" :range-color="['#ebedf0', '#87a5af', '#658e95', '#44787a', '#24635e', '#004d40']" :no-data-text="'No learning experiences on this date'" :tooltip-unit="'learning experiences'" />

          <div class="row" style="justify-content: space-evenly; margin-top: 1vh; margin-bottom: 2vh">
            <q-card class="my-card" style="height: 12vh">
              <q-card-section style="text-align: center">
                <div class="text-h3" style="
                    font-family: Lato;
                    font-weight: 500;
                    color: #4a7d9d;
                  ">
                  {{parseInt(totalLearningSessions, 10)}}
                </div>
                <div class="text-h7" style="font-family: Lato; font-weight: 500">
                  learning experiences
                </div>
              </q-card-section>
            </q-card>
            <q-card class="my-card" style="height: 12vh">
              <q-card-section style="text-align: center">
                <div class="text-h3" style="
                    font-family: Lato;
                    font-weight: 500;
                    color: #4a7d9d;
                  ">
                  {{Math.round(parseFloat(totalLearningHours, 10) * 100) / 100}}
                </div>
                <div class="text-h7" style="font-family: Lato; font-weight: 500">
                  hours learning
                </div>
              </q-card-section>
            </q-card>
            <q-card class="my-card" style="height: 12vh">
              <q-card-section style="text-align: center">
                <div class="text-h3" style="
                    font-family: Lato;
                    font-weight: 500;
                    color: #4a7d9d;
                  ">
                  {{learningData.length}}
                </div>
                <div class="text-h7" style="font-family: Lato; font-weight: 500">
                  subjects learned
                </div>
              </q-card-section>
            </q-card>
            <q-card class="my-card" style="height: 12vh">
              <q-card-section style="text-align: center">
                <div class="text-h3" style="
                    font-family: Lato;
                    font-weight: 500;
                    color: #4a7d9d;
                  ">
                  {{parseInt(totalCreditsSpent, 10)}}
                </div>
                <div class="text-h7" style="font-family: Lato; font-weight: 500">
                  credits spent
                </div>
              </q-card-section>
            </q-card>
          </div>


        </q-tab-panel>

        <q-tab-panel name="sessions">
          <div class="text-h6" style="margin-bottom: 1vh; font-family: Lato"><b>Session History</b></div>
            <div v-if="sessionData.length === 0">
              <text class="text-h7 text-bold" style="font-family: Lato">No sessions to display</text>
            </div>
            <div v-else v-for="(session, index) in sessionData" v-bind:key="index">
              <q-card class="my-card bg-teal-3" flat bordered style="margin-bottom: 2.5vh;">
              <q-item>
                <q-item-section avatar>
                  <q-avatar @click="$router.replace('/profile/' + session.otherPartyUsername)">
                    <img v-bind:src="sessionDataPFPSrcArr[index] === 'blank' ? require(`../assets/blank-avatar.png`) : sessionDataPFPSrcArr[index]">
                  </q-avatar>
                </q-item-section>

                <q-item-section>
                  <div class="row" style="height: 4vh;">
                    <div class="col-4">
                      <q-item-label v-if="session.sessionType === 'Tutored'" style="font-family: Lato">Tutored
                        {{ session.otherParty }}</q-item-label>
                      <q-item-label v-else-if="session.sessionType === 'Requested'" style="font-family: Lato">Tutored by {{ session.otherParty }}</q-item-label>
                      <q-item-label caption style="font-family: Lato">
                        {{ session.sessionTime }}
                      </q-item-label>
                    </div>

                    <q-separator vertical />

                    <div class="col-5" style="padding-left: 0.5vw">
                      <q-item-label class="text-bold" style="font-family: Lato">{{ session.subjects }}</q-item-label>
                      <q-item-label caption class="text-bold" style="font-family: Lato">
                        {{ session.bounty }} Credits
                      </q-item-label>
                    </div>
                  </div>
                </q-item-section>



            </q-item>

            <q-separator />

            <q-card-section horizontal>
              <q-card-section class="col-8">
                <text style="font-family: Lato;">{{
                    session.truncatedQuestion
                  }}</text>
                <!--
                <div v-if="username.length<8">Welcome, {{ username }}</div>
                <div v-else>Welcome, {{ username.substring(0,8)+".." }}</div> -->
              </q-card-section>
              <div class="col-4 q-pa-md text-center">
                <q-btn
                    round
                    color="deep-orange-10"
                    icon="assignment"
                    @click="setMoreInfoDialog(index)"
                />
                <q-item-label caption class="text-bold" style="margin-top: 1vh; font-family: Lato;">
                  More Info
                </q-item-label>
              </div>
            </q-card-section>
          </q-card>

          <q-dialog v-model="moreInfoDialog[index]" no-esc-dismiss no-backdrop-dismiss>
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Session Info</div>
              </q-card-section>
              <q-separator />
              <q-card-section style="padding-top: 0.5vh">
                <p class="text-caption text-teal-10 " style="font-family: Lato; word-wrap: break-word"><b>Question</b>: <text class="text-black">{{session.question}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Date</b>: <text class="text-black">{{session.sessionTime.substr(0, 12)}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Time</b>: <text class="text-black">{{session.sessionTime.substr(12)}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Subjects</b>: <text class="text-black">{{session.subjects}}</text></p>
                <p class="text-caption text-teal-10" style="font-family: Lato"><b>Bounty</b>: <text class="text-black">{{session.bounty}}</text></p>
                <p v-if="session.sessionType === 'Tutored'" class="text-caption text-teal-10" style="font-family: Lato"><b>Person Tutored</b>: <text class="text-black">{{session.otherParty}}</text></p>
                <p v-if="session.sessionType === 'Requested'" class="text-caption text-teal-10" style="font-family: Lato"><b>Person Tutored By</b>: <text class="text-black">{{session.otherParty}}</text></p>

              </q-card-section>

              <q-separator />

              <q-card-actions align="right">
                <q-btn flat label="Got the info, thanks!" color="red-10" v-close-popup style="font-family: Lato" no-caps/>

              </q-card-actions>
            </q-card>
          </q-dialog>
          </div>
        </q-tab-panel>

        <q-tab-panel name="verification">
          <p class="text-h6" style="font-family: Lato; font-weight: 700; text-align: left; margin-bottom: 0">
            Verification
          </p>
          <p v-if="!userVerified" class="text-h7" style="font-family: Lato; text-align: left; margin-bottom: 0">
            You have not verified yourself yet. To finish verification, please click on the button below. <br>You will need a photo of your school-issued ID with a photo of yourself on it. We use these photos to help verify that our platform consists of real users. While you can receive tutoring sessions without verifying your identity, you will receive <b>1000 bonus credits</b> if you verify yourself. You will also complete one of the steps for tutoring eligibility.
          </p>
          <p v-else class="text-h7" style="font-family: Lato; text-align: left; margin-bottom: 0">
            You have verified yourself successfully. You can change your verification image if you would like by clicking the button below.
          </p>
          <q-btn v-if="!userVerified" no-caps push label="Verify Identity" style="background-color: #A8D0E6; border-radius: 20px; width: 12vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 2vh;" label-color="grey-7" @click="verifyIdentity" />

          <q-btn v-else no-caps push label="Change Verification Image" style="background-color: #A8D0E6; border-radius: 20px; width: 15vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 1vh; margin-bottom: 1vh" label-color="grey-7" @click="verifyIdentity" />

          <p v-if="userVerified" class="text-h7" style="font-family: Lato; text-align: left; margin-bottom: 0">
            This is what your current ID image looks like.
          </p>

          <img v-if="userVerified" id="userIDImage" v-bind:src="userIDImageSrc" />


          <q-dialog v-model="verificationDialog" no-esc-dismiss no-backdrop-dismiss @hide="resetImage" @show="resetImage">
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Identity Verification</div>
              </q-card-section>
              <div>
                <q-form @submit="submitImage">
                  <q-separator />
                  <q-card-section style="padding-top: 0.5vh; margin-top: 1vh">
                    <q-file color="teal-10" outlined v-model="verificationImage" label="Upload Image" style="margin-bottom: 1vh; font-family: Lato" label-color="teal-10" accept=".jpg, .png, image/*" @change="imager" :disable="disabledImage" :rules="[val => val != null || 'Please select an image!']"/>
                    <q-btn no-caps push label="Clear Image" color="teal-3" @click="resetImage" style="font-family: Lato; margin-bottom: 1vh"/>

                    <div id="imgPreview">

                    </div>



                    <q-input color="teal-10" bg-color="white" outlined v-model="nameText" label="Name on photo of ID" label-color="teal-10" style="font-family: Lato;" :rules="[val => val.length > 0 || 'Please enter the name on the photo!']" />




                  </q-card-section>

                  <q-separator />

                  <q-card-actions align="right">
                    <q-btn flat label="Cancel Verification" color="red-10" v-close-popup style="font-family: Lato" no-caps />
                    <q-btn push label="Submit Image for Verification" color="teal-10" type="submit" style="font-family: Lato" no-caps/>

                  </q-card-actions>
                </q-form>
              </div>
            </q-card>
          </q-dialog>


          <p class="text-h6" style="font-family: Lato; font-weight: 700; text-align: left; margin-bottom: 0; margin-top: 1vh">
            Subjects Profile
          </p>
          <p v-if="userSubjectProfile.length === 0" class="text-h7" style="font-family: Lato; text-align: left; margin-bottom: 0">
            Filling out your subject profile is the second step for tutoring eligibility. This is so that <b style="font-family: Montserrat;">zerudite</b> users can see which subjects you are capable of tutoring. Please remember to only accept requests that you know you can tutor well - bad tutoring will result in strikes and eventual bans from our platform!
          </p>

          <p v-else class="text-h7" style="font-family: Lato; text-align: left; margin-bottom: 0">
            You have filled out your subject profile. You can edit it by clicking the button below.
          </p>

          <q-btn v-if="userSubjectProfile.length === 0" no-caps push label="Set Subject Profile" style="background-color: #A8D0E6; border-radius: 20px; width: 12vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 2vh;" label-color="grey-7" @click="subjectProfile" />

          <q-btn v-else no-caps push label="Edit Subject Profile" style="background-color: #A8D0E6; border-radius: 20px; width: 12vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 1vh; margin-bottom: 1vh" label-color="grey-7" @click="subjectProfile" />

          <p v-if="userSubjectProfile.length !== 0" class="text-h7" style="font-family: Lato; text-align: left; margin-bottom: 0">
            These are the ratings of your subjects, as you reported them.
          </p>

          <div v-if="userSubjectProfile.length !== 0">
            <div v-for="(subjectRating, indexOfRating) in userSubjectProfile" v-bind:key="subjectRating">
              <text class="text-h7 text-bold" style="font-family: Lato">{{subjectRating.subject}}</text><br>
              <q-rating
                  v-model="userSubjectProfile[indexOfRating].rating"
                  size="2em"
                  :max="5"
                  color="yellow-10"
                  icon-half="star_half"
                  readonly
              />
            </div>
          </div>


          <q-dialog v-model="subjectDialog" no-esc-dismiss no-backdrop-dismiss>
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Subject Profile</div>
              </q-card-section>
              <div>
                <q-form @submit="subjectSubmit">
                  <q-separator />
                  <q-card-section style="padding-top: 0.5vh; margin-top: 1vh">
                    <p class="text-h7" style="font-family: Lato; text-align: left; margin-bottom: 0">
                      Please select the subjects that you are experienced with. After selecting all the subjects you wish, click <i>Add Subjects</i>. Next, you will be asked to rate your level of expertise on each of these subjects. <br> <b>Please be honest</b> - nobody is perfect! This information will appear on your profile and may increase your credibility, allowing users to trust you as a tutor.
                    </p>
                    <q-select
                        v-model="selectedSubjects"
                        clearable
                        use-input
                        input-debounce="0"
                        label="Add subject"
                        :options="options"
                        @filter="filterFn"
                        style="font-family: Lato"
                        color="teal-10"
                        use-chips
                        multiple
                        :rules="[val => val.length > 0 || 'Please select a subject!']"
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-grey">
                            No subjects
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>


                  </q-card-section>

                  <q-separator />

                  <q-card-actions align="right">
                    <q-btn flat label="Cancel" color="red-10" v-close-popup style="font-family: Lato" no-caps />
                    <q-btn push label="Add Subjects" color="teal-10" type="submit" style="font-family: Lato" no-caps/>

                  </q-card-actions>
                </q-form>
              </div>
            </q-card>
          </q-dialog>

          <q-dialog v-model="subjectRateDialog" no-esc-dismiss no-backdrop-dismiss>
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Subject Ratings</div>
              </q-card-section>
              <div>
                <q-form @submit="subjectRatingSubmit">
                  <q-separator />
                  <q-card-section style="padding-top: 0.5vh; margin-top: 1vh">
                    <p class="text-h7" style="font-family: Lato; text-align: left; margin-bottom: 1vh">
                      Please rate your expertise on each subject on a scale from <b>1 to 5</b>, where <b>5</b> represents being able to answer any question about the subject and where <b>1</b> represents having a slight background on the subject, but not enough to help with very specific or advanced questions.
                    </p>

                    <div v-for="(subject, indexs) in selectedSubjects" v-bind:key="indexs">
                      <p class="text-h7 text-bold" style="font-family: Lato; text-align: left; margin-bottom: 0">
                        {{subject}}
                      </p>
                      <q-slider
                          v-model="subjectRatings[indexs]"
                          :min="1"
                          :max="5"
                          :step="0.5"
                          snap
                          label
                          color="teal-10"
                      />
                    </div>


                  </q-card-section>

                  <q-separator />

                  <q-card-actions align="right">
                    <q-btn flat label="Cancel" color="red-10" v-close-popup style="font-family: Lato" no-caps />
                    <q-btn push label="Submit Data" color="teal-10" type="submit" style="font-family: Lato" no-caps/>

                  </q-card-actions>
                </q-form>
              </div>
            </q-card>
          </q-dialog>

        </q-tab-panel>
        <q-tab-panel name="edit">
          <p class="text-h6 text-bold" style="font-family: Lato; text-align: left; margin-bottom: 0">
            Profile Editing
          </p>
          <text class="text-h7 text-bold" style="font-family: Lato; text-align: left;">
            Edit your profile picture
          </text><br>
          <q-btn no-caps push label="Edit Profile Picture" style="background-color: #A8D0E6; border-radius: 20px; width: 12vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-bottom: 1vh; margin-top: 1vh" label-color="grey-7" @click="profilePictureDialog = true" />

          <q-dialog v-model="profilePictureDialog" no-esc-dismiss no-backdrop-dismiss>
            <q-card flat bordered style="width: 40vw">
              <q-card-section>
                <div class="text-h5 q-mb-xs-xs" style="font-family: Lato">Change Profile Picture</div>
              </q-card-section>
              <div>
                <q-form @submit="profilePictureSubmit">
                  <q-separator />
                  <q-card-section style="padding-top: 0.5vh; margin-top: 1vh">
                    <q-file color="teal-10" outlined v-model="profileImage" label="Upload Image" style="margin-bottom: 1vh; font-family: Lato" label-color="teal-10" accept=".jpg, .png, image/*" @change="imagerPFP" :disable="disabledImagePFP" :rules="[val => val != null || 'Please select an image!']"/>
                    <q-btn no-caps push label="Clear Image" color="teal-3" @click="resetImagePFP" style="font-family: Lato; margin-bottom: 1vh"/>

                    <div id="imgPreviewPFP">

                    </div>
                  </q-card-section>

                  <q-separator />

                  <q-card-actions align="right">
                    <q-btn flat label="Cancel" color="red-10" v-close-popup style="font-family: Lato" no-caps />
                    <q-btn push label="Submit Picture" color="teal-10" type="submit" style="font-family: Lato" no-caps/>

                  </q-card-actions>
                </q-form>
              </div>
            </q-card>
          </q-dialog>

          <q-form @submit="setName">
            <br>
            <text class="text-h7 text-bold" style="font-family: Lato; text-align: left; margin-bottom: 1vh; padding-top: 1vh">
              Edit your name
            </text>
            <q-input color="teal-10" bg-color="white" outlined v-model="editNameText" label="Change your name" label-color="teal-10" style="font-family: Lato;" :rules="[val => val.length > 4 || 'Name must be longer than 4 characters']" />
            <q-btn no-caps push label="Edit Name" style="background-color: #A8D0E6; border-radius: 20px; width: 8vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 2vh; margin-bottom: 2vh" label-color="grey-7" type="submit" />
          </q-form>

          <q-form @submit="setGrade">
            <text class="text-h7 text-bold" style="font-family: Lato; text-align: left; margin-bottom: 1vh; padding-top: 1vh">
              Edit your grade
            </text>
            <q-select color="white" bg-color="white" outlined v-model="editGradeText" label="Select your grade" label-color="teal-10" style="font-family: Lato;" :options="gradeOptions" :rules="[val => val !== null || 'Please select a grade']"/>
            <q-btn no-caps push label="Edit Grade" style="background-color: #A8D0E6; border-radius: 20px; width: 8vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 2vh; margin-bottom: 2vh" label-color="grey-7" type="submit" />
          </q-form>

          <q-form @submit="setSchool">
            <text class="text-h7 text-bold" style="font-family: Lato; text-align: left; margin-bottom: 1vh; padding-top: 1vh">
              Edit your school
            </text>
            <q-input color="teal-10" bg-color="white" outlined v-model="editSchoolText" label="Change your school's name" label-color="teal-10" style="font-family: Lato;" :rules="[val => val.length > 10 || 'School name must be longer than 10 characters']" />
            <q-btn no-caps push label="Edit School" style="background-color: #A8D0E6; border-radius: 20px; width: 8vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 2vh; margin-bottom: 2vh" label-color="grey-7" type="submit" />
          </q-form>

          <q-form @submit="setDescription">
            <text class="text-h7 text-bold" style="font-family: Lato; text-align: left; margin-bottom: 1vh; padding-top: 1vh">
              Edit your profile description
            </text>
            <q-input color="teal-10" bg-color="white" outlined v-model="editDescText" label="Change your description" label-color="teal-10" style="font-family: Lato;" :rules="[val => val.length > 4 || 'Description must be longer than 4 characters', val => val.length < 200 || 'Description must be shorter than 200 characters']" />
            <q-btn no-caps push label="Edit Description" style="background-color: #A8D0E6; border-radius: 20px; width: 10vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 2vh; margin-bottom: 2vh" label-color="grey-7" type="submit" />
          </q-form>

          <q-form @submit="setEmail">
            <text class="text-h7 text-bold" style="font-family: Lato; text-align: left; margin-bottom: 1vh; padding-top: 1vh">
              Edit your email
            </text>
            <q-input color="teal-10" bg-color="white" outlined v-model="editEmailText" label="Change your email" label-color="teal-10" style="font-family: Lato;" :rules="[val => val.length > 0 || 'Please enter your email address', emailValidator, checkEmail]" />
            <q-btn no-caps push label="Edit Email" style="background-color: #A8D0E6; border-radius: 20px; width: 8vw; white-space: nowrap; color: black; font-family: Montserrat; font-weight: 600; margin-top: 2vh; margin-bottom: 2vh" label-color="grey-7" type="submit" />
          </q-form>

        </q-tab-panel>

      </q-tab-panels>
    </div>
  </div>
</template>


<script>
import {getCurrentInstance, ref} from "vue";
import InternalNavBar from "@/components/internal-navbar";
import {CalendarHeatmap} from 'vue3-calendar-heatmap'
import firebase from "firebase";
import 'datejs';
import { Dialog } from "quasar";
const constOptions = ["Accounting", "Business law", "Business management", "Consumer education", "Entrepreneurial skills", "Introduction to business", "Marketing ", "Personal finance", "Animation", "App development", "Audio production", "Computer programming", "Computer repair", "Film production", "Graphic design", "Keyboarding", "Media technology", "Music production", "Video game development", "Web design", "Web programming", "Word processing ", "AP Computer Science A", "AP Computer Science Principles", "American literature", "British literature", "Contemporary literature", "Creative writing", "Communication skills", "Debate", "English language and composition", "English literature and composition", "Humanities", "Journalism", "Literary analysis", "Modern literature", "Poetry", "Popular literature", "Rhetoric", "Shakespeare", "Technical writing", "World literature", "Written and oral communication", "AP English Language and Composition", "AP English Literature and Composition", "Chemistry of foods", "CPR training", "Culinary arts", "Early childhood development", "Early childhood education", "Family studies", "Fashion and retail merchandising", "Fashion construction", "Home economics", "Interior design", "Nutrition", "American Sign Language", "Ancient Greek", "Arabic", "Chinese", "French", "German", "Hebrew", "Italian", "Japanese", "Korean", "Latin", "Portuguese", "Russian", "Spanish", "AP Chinese Language and Culture", "AP French Language and Culture", "AP German Language and Culture", "AP Italian Language and Culture", "AP Japanese Language and Culture", "AP Latin", "AP Spanish Language and Culture", "AP Spanish Literature and Culture", "Algebra 1", "Algebra 2", "Calculus", "Computer math", "Consumer math", "Fundamentals of math", "Geometry", "Integrated math", "Math applications", "Multivariable calculus", "Practical math", "Pre-algebra", "Pre-calculus", "Probability", "Quantitative literacy", "Statistics", "Trigonometry", "AP Calculus AB", "AP Calculus BC", "AP Statistics", "Choir", "Concert band", "Dance", "Drama", "Guitar", "Jazz band", "Marching band", "Music theory", "Orchestra", "Percussion", "Piano ", "Theater technology", "World music", "Aerobics", "Dance", "Gymnastics", "Health", "Lifeguard training", "Pilates", "Racket sports", "Specialized sports", "Swimming", "Weight training", "Yoga", "Agriculture", "Astronomy", "Biology", "Botany", "Chemistry", "Earth science", "Electronics", "Environmental science", "Environmental studies", "Forensic science", "Geology", "Marine biology", "Oceanography", "Physical science", "Physics", "Zoology", "AP Biology", "AP Chemistry", "AP Environmental Science", "AP Physics C: Electricity and Magnetism", "AP Physics C: Mechanics", "AP Physics 1: Algebra-Based", "AP Physics 2: Algebra-Based", "Cultural anthropology", "Current events", "European history", "Geography", "Global studies", "Human geography", "International relations", "Law", "Macroeconomics", "Microeconomics", "Modern world studies", "Physical anthropology", "Political studies", "Psychology", "Religious studies", "Sociology", "US government", "US history", "Women’s studies", "World history", "World politics", "World religions", "AP Comparative Government and Politics", "AP European History", "AP Human Geography", "AP Macroeconomics", "AP Microeconomics", "AP Psychology", "AP United States Government and Politics", "AP United States History", "AP World History", "3-D art", "Art history", "Ceramics", "Digital media", "Drawing", "Film production", "Jewelry design", "Painting", "Photography", "Printmaking", "Sculpture", "AP Art History", "AP Music Theory", "AP Studio Art: 2-D Design", "AP Studio Art: 3-D Design", "AP Studio Art: Drawing", "Auto body repair", "Auto mechanics", "Building construction", "Computer-aided drafting", "Cosmetology", "Criminal justice", "Driver education", "Electronics", "FFA", "Fire science", "Heating and cooling systems", "Hospitality and tourism", "JROTC", "Metalworking", "Networking", "Plumbing", "Production technology", "Refrigeration fundamentals", "Robotics", "Woodworking"]
export default {
  name: "Name",
  components: {
    InternalNavBar,
    CalendarHeatmap
  },
  setup() {
    const internalInstance = getCurrentInstance()
    var options = ref(constOptions)
    var profileData = ref({})
    var sessionData = ref([])
    var tutoredData = ref({})
    var learningData = ref([])
    var userVerified = ref(false)
    var userSubjectProfile = ref([])
    var userIDImageSrc = ref("")
    var PFPSrc = ref(null)
    var sessionDataPFPSrcArr = ref([])
    var gradeOptions = ["Below Primary School", "First Grade", "Second Grade", "Third Grade", "Fourth Grade", "Fifth Grade", "Sixth Grade",
                        "Seventh Grade", "Eighth Grade", "Ninth Grade (Freshman)", "Tenth Grade (Sophomore)",
                        "Eleventh Grade (Junior)", "Twelfth Grade (Senior)", "Beyond High School"]

    var totalTutoredSessions = 0
    var totalTutoredHours = 0
    var totalCreditsEarned = 0
    var totalLearningSessions = 0
    var totalLearningHours = 0
    var totalCreditsSpent = 0

    var endDate = new Date()
    var tutoredHeatMapValues = []
    var learningHeatMapValues = []
    var verificationDialog = ref(false)
    var verificationImage = ref(null)
    var nameText = ref("")
    var disabledImage = ref(false)
    var subjectDialog = ref(false)
    var selectedSubjects = ref([])
    var subjectRateDialog = ref(false)
    var subjectRatings = ref([])
    var profilePictureDialog = ref(false)
    var profileImage = ref(null)
    var disabledImagePFP = ref(false)
    var moreInfoDialog = ref([])

    var editNameText = ref("")
    var editGradeText = ref(null)
    var editSchoolText = ref("")
    var editDescText = ref("")
    var editEmailText = ref("")

    return {
      endDate,
      tab: ref("overview"),
      fixed: ref(false),
      date: ref("2019-02-01 12:44"),
      verificationDialog,
      verificationImage,
      nameText,
      disabledImage,
      internalInstance,
      subjectDialog,
      options,
      subjectRateDialog,
      subjectRatings,
      profileData,
      sessionData,
      tutoredData,
      learningData,
      tutoredHeatMapValues,
      learningHeatMapValues,
      totalTutoredSessions,
      totalTutoredHours,
      totalCreditsEarned,
      totalLearningSessions,
      totalLearningHours,
      totalCreditsSpent,
      userVerified,
      userSubjectProfile,
      profilePictureDialog,
      profileImage,
      disabledImagePFP,
      userIDImageSrc,
      PFPSrc,
      editNameText,
      editGradeText,
      editSchoolText,
      editDescText,
      editEmailText,
      gradeOptions,
      moreInfoDialog,
      sessionDataPFPSrcArr,
      filterFn (val, update) {
        if (val === '') {
          update(() => {
            options.value = constOptions

            // here you have access to "ref" which
            // is the Vue reference of the QSelect
          })
          return
        }

        update(() => {
          const needle = val.toLowerCase()
          options.value = constOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
        })
      },
      selectedSubjects
    }
  },
  methods: {
    emailValidator () {
      const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/
      return emailPattern.test(this.editEmailText) || 'Please enter a valid email address'
    },
    async checkEmail() {
      try {
        let emailCheck = await firebase.auth().fetchSignInMethodsForEmail(this.editEmailText)
        return emailCheck.length === 0 || 'This email is already in use!'
      } catch (e) {
        // this comment exists only to make ESLint work. fuck ESLint
      }
    },
    async setName() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL
      let user = await firebase.auth().currentUser
      let IDToken = await user.getIdToken(true)

      let response = await fetch(url + '/setName', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken,
          name: this.editNameText
        })
      })
      let result = await response.json()
      if (result.code !== "SUCCESSFUL") {
          Dialog.create({
            title: 'Data Not Submitted',
            message: 'Your profile was not edited successfully. Please try again. Error: ' + result.code,
            persistent: true
          }).onOk(async () => {
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
      } else {
          Dialog.create({
            title: 'Data Submitted',
            message: 'Your profile was edited successfully! Refresh the page to see the changes.',
            persistent: true
          }).onOk(async () => {
          }).onCancel(() => {
            // console.log('Cancel')
          }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          })
      }
    },
    async setGrade() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL
      let user = await firebase.auth().currentUser
      let IDToken = await user.getIdToken(true)

      let response = await fetch(url + '/setGrade', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken,
          grade: this.editGradeText
        })
      })
      let result = await response.json()
      if (result.code !== "SUCCESSFUL") {
        Dialog.create({
          title: 'Data Not Submitted',
          message: 'Your profile was not edited successfully. Please try again. Error: ' + result.code,
          persistent: true
        }).onOk(async () => {
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      } else {
        Dialog.create({
          title: 'Data Submitted',
          message: 'Your profile was edited successfully! Refresh the page to see the changes.',
          persistent: true
        }).onOk(async () => {
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      }
    },
    async setSchool() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL
      let user = await firebase.auth().currentUser
      let IDToken = await user.getIdToken(true)

      let response = await fetch(url + '/setSchool', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken,
          school: this.editSchoolText
        })
      })
      let result = await response.json()
      if (result.code !== "SUCCESSFUL") {
        Dialog.create({
          title: 'Data Not Submitted',
          message: 'Your profile was not edited successfully. Please try again. Error: ' + result.code,
          persistent: true
        }).onOk(async () => {
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      } else {
        Dialog.create({
          title: 'Data Submitted',
          message: 'Your profile was edited successfully! Refresh the page to see the changes.',
          persistent: true
        }).onOk(async () => {
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      }
    },
    async setDescription() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL
      let user = await firebase.auth().currentUser
      let IDToken = await user.getIdToken(true)

      let response = await fetch(url + '/setDescription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken,
          description: this.editDescText
        })
      })
      let result = await response.json()
      if (result.code !== "SUCCESSFUL") {
        Dialog.create({
          title: 'Data Not Submitted',
          message: 'Your profile was not edited successfully. Please try again. Error: ' + result.code,
          persistent: true
        }).onOk(async () => {
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      } else {
        Dialog.create({
          title: 'Data Submitted',
          message: 'Your profile was edited successfully! Refresh the page to see the changes.',
          persistent: true
        }).onOk(async () => {
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      }
    },
    async setEmail() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL
      let user = await firebase.auth().currentUser

      let IDToken = await user.getIdToken(true)

      let response = await fetch(url + '/setEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken,
          email: this.editEmailText
        })
      })
      let result = await response.json()
      if (result.code !== "SUCCESSFUL") {
        Dialog.create({
          title: 'Data Not Submitted',
          message: 'Your profile was not edited successfully. Please try again. Error: ' + result.code,
          persistent: true
        }).onOk(async () => {
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      } else {
        Dialog.create({
          title: 'Data Submitted',
          message: 'Your profile was edited successfully! You will now be logged out due to your email change. Please log back in.',
          persistent: true
        }).onOk(async () => {
          await firebase.auth().currentUser.updateEmail(this.editEmailText)
          await firebase.auth().currentUser.sendEmailVerification()
          await firebase.auth().signOut()
          await this.$router.replace('/login')
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })

      }
    },
    verifyIdentity() {
      this.verificationDialog = true
    },
    subjectProfile() {
      this.subjectDialog = true
    },
    subjectSubmit() {
      this.subjectDialog = false
      this.subjectRateDialog = true
    },
    async subjectRatingSubmit() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL

      let user = await firebase.auth().currentUser

      let IDToken = await user.getIdToken(true)

      let subjects = []

      for (let i = 0; i < this.selectedSubjects.length; i++) {
          subjects.push({
            "subject": this.selectedSubjects[i],
            "rating": this.subjectRatings[i]
          })
      }

      let response = await fetch(url + '/setProfileSubjects', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken,
          subjects: JSON.stringify(subjects)
        })
      })

      let result = await response.json()
      console.log(result)
      if (result.code !== "SUCCESSFUL") {
        Dialog.create({
          title: 'Data Not Submitted',
          message: 'Your subject data was not submitted successfully. Please try again. Error: ' + result.code,
          persistent: true
        }).onOk(async () => {
          this.subjectRateDialog = false
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      } else {
        Dialog.create({
          title: 'Data Submitted',
          message: 'Your subject data was submitted successfully!',
          persistent: true
        }).onOk(async () => {
          this.subjectDialog = false
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
        this.subjectRateDialog = false
      }
    },
    async imager() {
      var reader = new FileReader()
      reader.onload = function (i) {
        var image = document.createElement('img')
        image.src = i.target.result
        document.getElementById('imgPreview').appendChild(image)
        image.style.width = "100%"
      }
      reader.readAsDataURL(this.verificationImage)
      this.disabledImage = true
    },
    resetImage() {
      this.verificationImage = ref(null)
      document.getElementById('imgPreview').innerHTML = ""
      this.disabledImage = false
    },
    async imagerPFP() {
      var reader = new FileReader()
      reader.onload = function (i) {
        var image = document.createElement('img')
        image.src = i.target.result
        document.getElementById('imgPreviewPFP').appendChild(image)
        image.style.width = "100%"
      }
      reader.readAsDataURL(this.profileImage)
      this.disabledImagePFP = true
    },
    resetImagePFP() {
      this.profileImage = ref(null)
      document.getElementById('imgPreviewPFP').innerHTML = ""
      this.disabledImagePFP = false
    },
    async submitImage() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL

      let IDToken = await firebase.auth().currentUser.getIdToken(true)

      var formData = new FormData()
      formData.append("image", this.verificationImage)
      formData.append("token", IDToken)

      let response = await fetch(url + '/uploadVerificationImage', {
        method: 'POST',
        body: formData,
      })

      let result = await response.json()
      if (result.code !== "SUCCESSFUL") {
        Dialog.create({
          title: 'Image Not Submitted',
          message: 'Your image was not submitted successfully. Please try again. Error: ' + result.code,
          persistent: true
        }).onOk(async () => {
          this.verificationDialog = false
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      } else {
        Dialog.create({
          title: 'Image Submitted',
          message: 'Your image was submitted successfully!',
          persistent: true
        }).onOk(async () => {
          this.verificationDialog = false
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      }
    },
    async profilePictureSubmit() {
      let url = this.internalInstance.appContext.config.globalProperties.$backendURL

      let IDToken = await firebase.auth().currentUser.getIdToken(true)

      var formData = new FormData()
      formData.append("image", this.profileImage)
      formData.append("token", IDToken)

      let response = await fetch(url + '/setPFP', {
        method: 'POST',
        body: formData,
      })

      let result = await response.json()
      if (result.code !== "SUCCESSFUL") {
        Dialog.create({
          title: 'Image Not Submitted',
          message: 'Your image was not submitted successfully. Please try again. Error: ' + result.code,
          persistent: true
        }).onOk(async () => {
          this.profilePictureDialog = false
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      } else {
        Dialog.create({
          title: 'Image Submitted',
          message: 'Your image was submitted successfully!',
          persistent: true
        }).onOk(async () => {
          this.profilePictureDialog = false
        }).onCancel(() => {
          // console.log('Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      }
    },
    setMoreInfoDialog(index) {
      this.moreInfoDialog[index] = true
    }
  },
  async mounted() {
    const internalInstance = getCurrentInstance()
    let url = internalInstance.appContext.config.globalProperties.$backendURL



    await firebase.auth().onAuthStateChanged(async (user) => {

      let IDToken = await user.getIdToken(true)

      let response = await fetch(url + '/getUserProfileDataUID', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: IDToken
        })
      })
      let result = await response.json()
      let profileData = result.profileData
      this.userSubjectProfile = profileData.subjects
      this.userVerified = profileData.verified


      response = await fetch(url + '/getUserSessionData', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: profileData.username,
        })
      })
      result = await response.json()
      let sessionData = result.sessionData



      let tutoredArr = []
      let learningArr = []
      let tutoredHeatMap = []
      let learningHeatMap = []

      for (let i = 0; i < sessionData.length; i++) {
        let tempSubjects = sessionData[i].subjects

        sessionData[i].truncatedQuestion = sessionData[i].question.substr(0, 240)
        if (sessionData[i].question.length > 240) {
          sessionData[i].truncatedQuestion = sessionData[i].truncatedQuestion + "..."
        }

        this.moreInfoDialog.push(false)

        let response = await fetch(url + '/getPFP', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: sessionData[i].otherPartyUsername
          })
        })
        let result = await response.json()
        this.sessionDataPFPSrcArr[i] = result.image == null ? "blank" : "data:image/png;base64," + result.image

        let subjectsString = ""

        if (sessionData[i].sessionType === "Tutored") {
          for (let j = 0; j < tempSubjects.length; j++) {
            subjectsString = subjectsString + tempSubjects[j].toString() + ", "
            let subjectFound = false
            for (let k = 0; k < tutoredArr.length; k++) {
              if (tutoredArr[k].subject === tempSubjects[j]) {
                tutoredArr[k].totalDuration += Math.round(parseFloat(sessionData[i].duration) * 100)/100
                tutoredArr[k].creditsEarned += sessionData[i].rating === "Positive" ? sessionData[i].bounty : 0
                tutoredArr[k].positiveRatings += sessionData[i].rating === "Positive" ? 1 : 0
                subjectFound = true
                break
              }
            }
            if (!subjectFound) {
              tutoredArr.push({
                subject: tempSubjects[j],
                totalDuration: Math.round(parseFloat(sessionData[i].duration) * 100)/100,
                creditsEarned: sessionData[i].rating === "Positive" ? sessionData[i].bounty : 0,
                positiveRatings: sessionData[i].rating === "Positive" ? 1 : 0
              })
            }
          }
          let dateFound = false
          let sessionDate = sessionData[i].sessionTime.substr(0, 10)
          if (sessionDate[8] === '0')
            sessionDate = sessionDate.slice(0, 8) + sessionDate.slice(9)
          if (sessionDate[5] === '0') {
            sessionDate = sessionDate.slice(0, 5) + sessionDate.slice(6)
          }

          for (let j = 0; j < tutoredHeatMap.length; j++) {
            if (tutoredHeatMap[j].date === sessionDate) {
              tutoredHeatMap[j].count++
              dateFound = true
              break
            }
          }
          if (!dateFound) {
            tutoredHeatMap.push({
              date: sessionDate,
              count: 1
            })
          }

          this.totalCreditsEarned += sessionData[i].bounty
          this.totalTutoredHours += sessionData[i].duration
          this.totalTutoredSessions++
        }
        else if (sessionData[i].sessionType === "Requested") {
          for (let j = 0; j < tempSubjects.length; j++) {
            subjectsString = subjectsString + tempSubjects[j].toString() + ", "
            let subjectFound = false
            for (let k = 0; k < learningArr.length; k++) {
              if (learningArr[k].subject === tempSubjects[j]) {
                learningArr[k].totalDuration += Math.round(parseFloat(sessionData[i].duration) * 100)/100
                learningArr[k].creditsEarned += sessionData[i].rating === "Positive" ? sessionData[i].bounty : 0
                learningArr[k].positiveRatings += sessionData[i].rating === "Positive" ? 1 : 0
                subjectFound = true
                break
              }
            }
            if (!subjectFound) {
              learningArr.push({
                subject: tempSubjects[j],
                totalDuration: Math.round(parseFloat(sessionData[i].duration) * 100)/100,
                creditsEarned: sessionData[i].rating === "Positive" ? sessionData[i].bounty : 0,
                positiveRatings: sessionData[i].rating === "Positive" ? 1 : 0
              })
            }
          }


          let dateFound = false
          let sessionDate = sessionData[i].sessionTime.substr(0, 10)
          if (sessionDate[8] === '0')
            sessionDate = sessionDate.slice(0, 8) + sessionDate.slice(9)
          if (sessionDate[5] === '0') {
            sessionDate = sessionDate.slice(0, 5) + sessionDate.slice(6)
          }

          for (let j = 0; j < learningHeatMap.length; j++) {
            if (learningHeatMap[j].date === sessionDate) {
              learningHeatMap[j].count++
              dateFound = true
              break
            }
          }
          if (!dateFound) {
            learningHeatMap.push({
              date: sessionDate,
              count: 1
            })
          }

          this.totalCreditsSpent += sessionData[i].bounty
          this.totalLearningHours += sessionData[i].duration
          this.totalLearningSessions++
        }

        const constdate = new Date()
        let time = new Date(sessionData[i].sessionTime).getTime()
        let offset = constdate.getTimezoneOffset() * 60000
        let newDate = new Date(time - offset)
        sessionData[i].sessionTime = Date.parse(newDate).toString("MMM dd, yyyy HH:mm")


        subjectsString = subjectsString.substr(0, subjectsString.length - 2)
        sessionData[i].subjects = subjectsString
      }

      this.sessionData = sessionData
      this.profileData = profileData
      this.tutoredData = tutoredArr
      this.learningData = learningArr
      this.tutoredHeatMapValues = tutoredHeatMap
      this.learningHeatMapValues = learningHeatMap

      if (this.userVerified) {
        response = await fetch(url + '/getVerificationImage', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: IDToken
          })
        })
        result = await response.json()
        this.userIDImageSrc = "data:image/png;base64," + result.image
      }


      response = await fetch(url + '/getPFP', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: profileData.username
        })
      })
      result = await response.json()
      this.PFPSrc = result.image == null ? "blank" : "data:image/png;base64," + result.image
    })

  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700;800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Gentium+Basic:ital,wght@0,400;0,700;1,400;1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap");
@font-face {
  font-family: "Farray";
  src: url("../assets/fonts/FARRAY.otf");
}
.text-caption {
  margin-bottom: 0vh;
}

</style>
